import { useMap } from '@vis.gl/react-maplibre';
import type { MapEventType } from 'maplibre-gl';
import { useEffect } from 'react';

interface UseMapOnEventProps<T extends keyof MapEventType> {
  type: T;
  listener: (event: MapEventType[T] & object) => void;
  enabled?: boolean;
  mapId?: string;
}

export const useMapOnEvent = <T extends keyof MapEventType>({
  type,
  listener,
  enabled = true,
  mapId = 'current',
}: UseMapOnEventProps<T>) => {
  const mapRef = useMap();

  useEffect(() => {
    const map = mapRef[mapId];

    if (enabled) {
      map?.on(type, listener);

      return () => {
        map?.off(type, listener);
      };
    }

    return () => {};
  }, [enabled, listener, mapId, mapRef, type]);
};
